import React, { useEffect, useState } from "react";
import PropType from "prop-types";

export default function HandleGenCapchaRandomRotate({ captcha }) {
  const a = [
    -15 + Math.trunc(Math.random() * 35),
    -15 + Math.trunc(Math.random() * 35),
    -15 + Math.trunc(Math.random() * 35),
  ];
  const [rotateAngel, setRotateAngel] = useState(a);
  // const rotate = -20 + Math.trunc(Math.random() * 30);
  useEffect(() => {
    setRotateAngel([
      -15 + Math.trunc(Math.random() * 35),
      -15 + Math.trunc(Math.random() * 35),
      -15 + Math.trunc(Math.random() * 35),
    ]);
  }, [captcha]);
  return (
    <div
      style={{
        height: "40px",
        display: "flex",
        width: "20%",
        border: "var(--blue-blue-100) 1px solid",
        borderRadius: "5px",
        fontSize: "25px",
        padding: "4px",
        color: "var(--blue-blue-100)",
        justifyContent: "space-around",
        fontFamily: "inherit",
        fontWeight: "600",
        userSelect: "none",
      }}
    >
      {captcha.split("").map((char, index) => (
        <div
          key={char + index}
          style={{
            padding: index === 1 ? "0px 5px 0px 5px" : "0px 0px 0px 0px",
            transform: `rotate(${rotateAngel[index]}deg)`,
          }}
        >
          {char}
        </div>
      ))}
    </div>
  );
}
HandleGenCapchaRandomRotate.propTypes = {
  captcha: PropType.string.isRequired,
};
